<template>
    <div>
        <van-nav-bar left-arrow class="product-serach"
        @click-left="onBack"
        :fixed="fixed" :placeholder="fplaceholder"
        >
            <van-search
            v-model="value"
            :placeholder="placeholder"
            background="#fff"
            @search="onSearch"
            @click="onclick"
            slot="title"
            :disabled="disabled"
            >
               
            </van-search>
            <van-button slot="right" v-if="showbtn" type="default"  size="small" @click="onSearch" >搜索</van-button>
        </van-nav-bar>
        

    </div>
</template>

<script>
import { Search } from "vant";

export default {
    name:'searchtop',
    components:{
        [Search.name]:Search,
    },
    props:{
        placeholder:{type:String,default:'请输入搜索关键词'},
        showbtn:{
            type:Boolean,
            default:true
        },
        disabled:{
            type:Boolean,
            default:false
        },
        fixed: {
            type: Boolean,
            default: true
        },
        fplaceholder:{
            type: Boolean,
            default: true
        }
    },
    data(){
        return{
            value:'',
        }
    },
    methods:{
        onSearch() {
            this.$emit('doSearch',this.value);
            console.log(this.value);
        },
        onBack() {
            history.back();
        },
        onclick(){
            this.$emit('doClick');
        }
    }
}
</script>
<style lang="scss" scoped>
// .product-serach{
//     .van-search{
//         padding: 7px 0;
//         background: #fff;
//         .van-cell{
//             background: rgb(242, 242, 242);
//             margin-right: 10px;
//         }
//         .van-search__action{
//             background: #e93b3d;
//             color: #fff;
//         }
//     }
//    
// }
.van-search{
    padding: 0;
}
 .van-nav-bar__title{
        margin: 0;
        max-width: 100%;
        padding-left: 40px;
    }
    .van-search__content{
        border-radius: 20px;
    }
</style>
